export default __webpack_public_path__ + "quick-actions-how-we-work.7561848e.svg";